import { configure } from 'vee-validate';

export default defineNuxtPlugin(nuxtApp => {
  // called right before setting a new locale
  nuxtApp.hook('i18n:beforeLocaleSwitch', ({ oldLocale, newLocale, initialSetup, context }) => {
    if (initialSetup) {
      configure({
        generateMessage: field => {
          const { $i18n } = useNuxtApp();
          if (field === '{field}') return '';
          if (!field.rule) return '';
          const params = field.rule.params || {};
          const message = $i18n.t(`validation.${field.rule.name}`, {
            min: params[0] || params.min || '',
            max: params[1] || params.max || ''
          });
          return message;
        }
      });
    }
    useHead(() => ({
      htmlAttrs: {
        lang: newLocale
      }
    }));
  });

  // called right after a new locale has been set
  nuxtApp.hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
    // console.log('onLanguageSwitched', oldLocale, newLocale);
  });
});
